
      window.versions = {
        script: 45,
        atlas: {
          preloader: 5,
          core: 8,
          "core-ui": 5,
          lobby: 8,
          competition: 1,
          popup: 7
        },
        layout: 14,
        sound: 1,
        font: 1,
        ambience: 1,
        descriptor: 9,
        image: 2
      }

      import(/* @vite-ignore */__ENTRY_FILE__);
    